/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {PlanSettings} from '../bioplanModels';
// @ts-ignore
import type {WritePlanSettings} from '../bioplanModels';
/**
 * PlanningPlanSettingsApi - axios parameter creator
 * @export
 */
export const PlanningPlanSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get plan settings
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planSettingsPlanIdGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('planSettingsPlanIdGet', 'planId', planId);
      const localVarPath = `/planSettings/{planId}`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update plan settings
     * @param {string} planId
     * @param {WritePlanSettings} writePlanSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planSettingsPlanIdPut: async (
      planId: string,
      writePlanSettings: WritePlanSettings,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('planSettingsPlanIdPut', 'planId', planId);
      // verify required parameter 'writePlanSettings' is not null or undefined
      assertParamExists('planSettingsPlanIdPut', 'writePlanSettings', writePlanSettings);
      const localVarPath = `/planSettings/{planId}`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writePlanSettings, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningPlanSettingsApi - functional programming interface
 * @export
 */
export const PlanningPlanSettingsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningPlanSettingsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get plan settings
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planSettingsPlanIdGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanSettings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planSettingsPlanIdGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanSettingsApi.planSettingsPlanIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update plan settings
     * @param {string} planId
     * @param {WritePlanSettings} writePlanSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planSettingsPlanIdPut(
      planId: string,
      writePlanSettings: WritePlanSettings,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanSettings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planSettingsPlanIdPut(
        planId,
        writePlanSettings,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanSettingsApi.planSettingsPlanIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningPlanSettingsApi - factory interface
 * @export
 */
export const PlanningPlanSettingsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningPlanSettingsApiFp(configuration);
  return {
    /**
     *
     * @summary Get plan settings
     * @param {PlanningPlanSettingsApiPlanSettingsPlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planSettingsPlanIdGet(
      requestParameters: PlanningPlanSettingsApiPlanSettingsPlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PlanSettings> {
      return localVarFp
        .planSettingsPlanIdGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update plan settings
     * @param {PlanningPlanSettingsApiPlanSettingsPlanIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planSettingsPlanIdPut(
      requestParameters: PlanningPlanSettingsApiPlanSettingsPlanIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PlanSettings> {
      return localVarFp
        .planSettingsPlanIdPut(requestParameters.planId, requestParameters.writePlanSettings, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for planSettingsPlanIdGet operation in PlanningPlanSettingsApi.
 * @export
 * @interface PlanningPlanSettingsApiPlanSettingsPlanIdGetRequest
 */
export interface PlanningPlanSettingsApiPlanSettingsPlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanSettingsApiPlanSettingsPlanIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for planSettingsPlanIdPut operation in PlanningPlanSettingsApi.
 * @export
 * @interface PlanningPlanSettingsApiPlanSettingsPlanIdPutRequest
 */
export interface PlanningPlanSettingsApiPlanSettingsPlanIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanSettingsApiPlanSettingsPlanIdPut
   */
  readonly planId: string;

  /**
   *
   * @type {WritePlanSettings}
   * @memberof PlanningPlanSettingsApiPlanSettingsPlanIdPut
   */
  readonly writePlanSettings: WritePlanSettings;
}

/**
 * PlanningPlanSettingsApi - object-oriented interface
 * @export
 * @class PlanningPlanSettingsApi
 * @extends {BaseAPI}
 */
export class PlanningPlanSettingsApi extends BaseAPI {
  /**
   *
   * @summary Get plan settings
   * @param {PlanningPlanSettingsApiPlanSettingsPlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanSettingsApi
   */
  public planSettingsPlanIdGet(
    requestParameters: PlanningPlanSettingsApiPlanSettingsPlanIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanSettingsApiFp(this.configuration)
      .planSettingsPlanIdGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update plan settings
   * @param {PlanningPlanSettingsApiPlanSettingsPlanIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanSettingsApi
   */
  public planSettingsPlanIdPut(
    requestParameters: PlanningPlanSettingsApiPlanSettingsPlanIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanSettingsApiFp(this.configuration)
      .planSettingsPlanIdPut(requestParameters.planId, requestParameters.writePlanSettings, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
